<template>
	<div>
		<pui-datatable
			:modelName="modelName"
			:actions="actions"
			:modelColumnDefs="modelColumnDefs"
		></pui-datatable>
		<mtipytamequipamiento-modals
			:modelName="modelName"
		></mtipytamequipamiento-modals>
	</div>
</template>

<script>
import mtipytamequipamientoActions from './MtipytamequipamientoActions';
import mtipytamequipamientoModals from './MtipytamequipamientoModals.vue';

export default {
	name: 'mtipytamequipamiento-grid',
	components: {
		'mtipytamequipamiento-modals': mtipytamequipamientoModals
	},
	data() {
		return {
			modelName: 'mtipytamequipamiento',
			actions: mtipytamequipamientoActions.gridactions,
			modelColumnDefs: {
			}
		}
	}
}
</script>
